import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [actions.TOPICS_FETCH_SUCCESS],
  updateSuccessTypes: [
    actions.TOPIC_UPDATE,
    actions.TOPIC_UPDATE_REVERT
  ],
  entityType: 'topics',
  updateKey: 'id'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/byId/reducer.js
 **/